import { render, staticRenderFns } from "./Escalation.vue?vue&type=template&id=2b579d36&"
import script from "./Escalation.vue?vue&type=script&lang=js&"
export * from "./Escalation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports